import { memo, useCallback } from "react";

import { routes } from "@/common/utils/routes";
import { SeeMoreBlock } from "components/blocks/SeeMoreBlock";
import { TagLink } from "components/widgets/TagList/TagLink";
import { ITag } from "@/common/services/types";
import { useGetTrendingTags } from "@/common/hooks/useGetTrendingTags";
import { metricsBus } from "@/common/buses";

const TrendingTagsComponent = () => {
  const { trendingTags } = useGetTrendingTags();

  const handleTagClick = useCallback((tag: ITag) => () => {
    metricsBus.emit("tagClicked", { tag: tag.name, section: "Trending Tags" });
  }, []);

  return (
    <SeeMoreBlock
      header="Trending Porn GIFs Tags"
      more={routes.trendingTags()}
      className="trendingTags canvas"
      list={true}
    >
      {trendingTags.map((tag: ITag) => (
        <TagLink
          key={tag.name}
          tag={tag}
          counts={true}
          onClick={handleTagClick(tag)}
        />
      ))}
    </SeeMoreBlock>
  );
};

export const TrendingTags = memo(TrendingTagsComponent);
